const firstTime = () => import('@/onBoard/views/FirstTimeView');

const routes = [
  {
    path: '/first-time',
    name: 'first-time',
    component: firstTime,
  },
];

export default (router) => {
  routes.forEach((element) => {
    router.addRoute('main', element);
  });
};
